/**
 * The RFP application's own routes, mounted by the shell at /rfp.
 *
 * Nothing in here knows it sits at /rfp — the prefix is the shell's decision, recorded once in
 * `platform/registry.ts`.
 */
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const RollupPage = lazy(() => import('@/apps/rfp/RollupPage'));
const RfpsPage = lazy(() => import('@/apps/rfp/RfpsPage'));
const RfpDetailPage = lazy(() => import('@/apps/rfp/RfpDetailPage'));
const RfpFormPage = lazy(() => import('@/apps/rfp/RfpFormPage'));
const WorkloadPage = lazy(() => import('@/apps/rfp/WorkloadPage'));

export const rfpRoutes = (
  <Route path="rfp">
    {/* RFP Status is the application's front page: it answers "where is everything" in one
        screen, which is what somebody opening the app is asking. */}
    <Route index element={<RollupPage />} />
    {/* The board was removed on 2026-10-23; a cell is edited from the RFP's Carriers tab.
        `rollup` was this screen's address for a fortnight. */}
    <Route path="board" element={<Navigate to="/rfp" replace />} />
    <Route path="rollup" element={<Navigate to="/rfp" replace />} />
    <Route path="requests" element={<RfpsPage />} />
    <Route path="requests/new" element={<RfpFormPage />} />
    <Route path="requests/:rfpId" element={<RfpDetailPage />} />
    <Route path="requests/:rfpId/edit" element={<RfpFormPage />} />
    <Route path="workload" element={<WorkloadPage />} />
  </Route>
);
